/** @format */

import {
    blackColor,
    dangerColor,
    grayColor,
    hexToRgb,
    infoColor,
    primaryColor,
    roseColor,
    successColor,
    warningColor,
    whiteColor,
} from '../../../../jss/material-dashboard-pro-react';
import OPL_STYLE from '../../OplStyle';
import COLORS from '../../colors';

const DEFAULT_BUTTON_COLOR = COLORS.DARK_FUNCTION.FUNCTION_1;

const PRIMARY_BUTTON_COLOR = OPL_STYLE.FONT.PRIMARY;
const PRIMARY_BUTTON_BACKGROUND_COLOR = COLORS.MAIN.PRIMARY;

const SECONDARY_BUTTON_COLOR = OPL_STYLE.FONT.COLOR;
const SECONDARY_BUTTON_BACKGROUND_COLOR = OPL_STYLE.BACKGROUND.PRIMARY;

const OplButtonStyle = {
    button: {
        minHeight: '32px',
        minWidth: '32px',
        backgroundColor: DEFAULT_BUTTON_COLOR,
        fill: PRIMARY_BUTTON_COLOR,
        color: PRIMARY_BUTTON_COLOR,
        fontWeight: 'bold',
        border: 'none',
        borderColor: 'none',
        borderRadius: 0,
        position: 'relative',
        margin: 2,
        fontSize: '0.6875rem',
        textTransform: 'none',
        letterSpacing: '0.5px',
        willChange: 'box-shadow, transform',
        transition: 'box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        lineHeight: '1.42857143',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        touchAction: 'manipulation',
        cursor: 'pointer',
        '&:hover,&:focus': {
            backgroundColor: PRIMARY_BUTTON_BACKGROUND_COLOR,
            borderColor: PRIMARY_BUTTON_BACKGROUND_COLOR,
            transition: 'opacity .15s',
            color: PRIMARY_BUTTON_COLOR,
            opacity: 0.85,
        },
        '& .fab,& .fas,& .far,& .fal,& .material-icons': {
            position: 'relative',
            display: 'inline-block',
            top: '0',
            marginTop: '-1em',
            marginBottom: '-1em',
            fontSize: '1.1rem',
            verticalAlign: 'middle',
        },
        '& svg': {
            position: 'relative',
            display: 'inline-block',
            top: '0',
            width: '18px',
            height: '18px',
            verticalAlign: 'middle',
        },
        '&$justIcon': {
            '& .fab,& .fas,& .far,& .fal,& .material-icons': {
                marginTop: '0px',
                position: 'absolute',
                width: '100%',
                transform: 'none',
                left: '0px',
                top: '0px',
                height: '100%',
                lineHeight: '41px',
                fontSize: '20px',
            },
        },
    },
    fullWidth: {
        width: '100%',
    },
    primary: {
        fill: PRIMARY_BUTTON_COLOR,
        color: PRIMARY_BUTTON_COLOR,
        backgroundColor: PRIMARY_BUTTON_BACKGROUND_COLOR,
        border: '2px solid',
        borderColor: PRIMARY_BUTTON_BACKGROUND_COLOR,
        '&:hover,&:focus': {
            borderColor: PRIMARY_BUTTON_BACKGROUND_COLOR,
            backgroundColor: PRIMARY_BUTTON_BACKGROUND_COLOR,
            opacity: 0.85,
        },
    },
    info: {
        backgroundColor: infoColor[0],
        boxShadow:
            '0 2px 2px 0 rgba(' +
            hexToRgb(infoColor[0]) +
            ', 0.14), 0 3px 1px -2px rgba(' +
            hexToRgb(infoColor[0]) +
            ', 0.2), 0 1px 5px 0 rgba(' +
            hexToRgb(infoColor[0]) +
            ', 0.12)',
        '&:hover,&:focus': {
            backgroundColor: infoColor[0],
            boxShadow:
                '0 14px 26px -12px rgba(' +
                hexToRgb(infoColor[0]) +
                ', 0.42), 0 4px 23px 0px rgba(' +
                hexToRgb(blackColor) +
                ', 0.12), 0 8px 10px -5px rgba(' +
                hexToRgb(infoColor[0]) +
                ', 0.2)',
        },
    },
    success: {
        backgroundColor: successColor[0],
        boxShadow:
            '0 2px 2px 0 rgba(' +
            hexToRgb(successColor[0]) +
            ', 0.14), 0 3px 1px -2px rgba(' +
            hexToRgb(successColor[0]) +
            ', 0.2), 0 1px 5px 0 rgba(' +
            hexToRgb(successColor[0]) +
            ', 0.12)',
        '&:hover,&:focus': {
            backgroundColor: successColor[0],
            boxShadow:
                '0 14px 26px -12px rgba(' +
                hexToRgb(successColor[0]) +
                ', 0.42), 0 4px 23px 0px rgba(' +
                hexToRgb(blackColor) +
                ', 0.12), 0 8px 10px -5px rgba(' +
                hexToRgb(successColor[0]) +
                ', 0.2)',
        },
    },
    warning: {
        backgroundColor: warningColor[0],
        boxShadow:
            '0 2px 2px 0 rgba(' +
            hexToRgb(warningColor[0]) +
            ', 0.14), 0 3px 1px -2px rgba(' +
            hexToRgb(warningColor[0]) +
            ', 0.2), 0 1px 5px 0 rgba(' +
            hexToRgb(warningColor[0]) +
            ', 0.12)',
        '&:hover,&:focus': {
            backgroundColor: warningColor[0],
            boxShadow:
                '0 14px 26px -12px rgba(' +
                hexToRgb(warningColor[0]) +
                ', 0.42), 0 4px 23px 0px rgba(' +
                hexToRgb(blackColor) +
                ', 0.12), 0 8px 10px -5px rgba(' +
                hexToRgb(warningColor[0]) +
                ', 0.2)',
        },
    },
    danger: {
        backgroundColor: dangerColor[0],
        boxShadow:
            '0 2px 2px 0 rgba(' +
            hexToRgb(dangerColor[0]) +
            ', 0.14), 0 3px 1px -2px rgba(' +
            hexToRgb(dangerColor[0]) +
            ', 0.2), 0 1px 5px 0 rgba(' +
            hexToRgb(dangerColor[0]) +
            ', 0.12)',
        '&:hover,&:focus': {
            backgroundColor: dangerColor[0],
            boxShadow:
                '0 14px 26px -12px rgba(' +
                hexToRgb(dangerColor[0]) +
                ', 0.42), 0 4px 23px 0px rgba(' +
                hexToRgb(blackColor) +
                ', 0.12), 0 8px 10px -5px rgba(' +
                hexToRgb(dangerColor[0]) +
                ', 0.2)',
        },
    },
    rose: {
        backgroundColor: roseColor[0],
        boxShadow:
            '0 2px 2px 0 rgba(' +
            hexToRgb(roseColor[0]) +
            ', 0.14), 0 3px 1px -2px rgba(' +
            hexToRgb(roseColor[0]) +
            ', 0.2), 0 1px 5px 0 rgba(' +
            hexToRgb(roseColor[0]) +
            ', 0.12)',
        '&:hover,&:focus': {
            backgroundColor: roseColor[0],
            boxShadow:
                '0 14px 26px -12px rgba(' +
                hexToRgb(roseColor[0]) +
                ', 0.42), 0 4px 23px 0px rgba(' +
                hexToRgb(blackColor) +
                ', 0.12), 0 8px 10px -5px rgba(' +
                hexToRgb(roseColor[0]) +
                ', 0.2)',
        },
    },
    white: {
        '&,&:focus,&:hover': {
            backgroundColor: whiteColor,
            color: grayColor[0],
        },
    },
    simple: {
        background: 'transparent',
        boxShadow: 'none',
        color: DEFAULT_BUTTON_COLOR,
        fill: DEFAULT_BUTTON_COLOR,
        '&:focus,&:hover': {
            background: 'transparent',
            boxShadow: 'none',
            color: SECONDARY_BUTTON_COLOR,
            fill: SECONDARY_BUTTON_COLOR,
        },
        '&$primary': {
            '&,&:focus,&:hover,&:visited': {
                color: primaryColor[0],
            },
        },
        '&$info': {
            '&,&:focus,&:hover,&:visited': {
                color: infoColor[0],
            },
        },
        '&$success': {
            '&,&:focus,&:hover,&:visited': {
                color: successColor[0],
            },
        },
        '&$warning': {
            '&,&:focus,&:hover,&:visited': {
                color: warningColor[0],
            },
        },
        '&$rose': {
            '&,&:focus,&:hover,&:visited': {
                color: roseColor[0],
            },
        },
        '&$danger': {
            '&,&:focus,&:hover,&:visited': {
                color: dangerColor[0],
            },
        },
    },
    transparent: {
        '&,&:focus,&:hover': {
            color: 'inherit',
            background: 'transparent',
            boxShadow: 'none',
        },
    },
    buttonDisabled: {
        opacity: '0.65',
        pointerEvents: 'none',
        cursor: 'default',
        backgroundColor: COLORS.DARK_FUNCTION.FUNCTION_4,
    },
    lg: {
        '&$justIcon': {
            '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
                marginTop: '-4px',
            },
        },
        height: 50,
        padding: '0 20px',
        textTransform: 'none',
        fontSize: '0.85rem',
    },
    sm: {
        '&$justIcon': {
            '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
                marginTop: '1px',
            },
        },
        padding: '0.40625rem 1.25rem',
        fontSize: '0.6875rem',
        textTransform: 'none',
        lineHeight: '1.5',
    },
    round: {
        borderRadius: '30px',
    },
    block: {
        width: '100% !important',
    },
    link: {
        '&,&:hover,&:focus': {
            backgroundColor: 'transparent',
            color: grayColor[0],
            boxShadow: 'none',
        },
    },
    justIcon: {
        paddingLeft: '12px',
        paddingRight: '12px',
        fontSize: '20px',
        height: '41px',
        minWidth: '41px',
        width: '41px',
        '& .fab,& .fas,& .far,& .fal,& svg,& .material-icons': {
            marginRight: '0px',
        },
        '&:focus': {
            backgroundColor: 'transparent',
            border: 'none',
        },
        '&$lg': {
            height: '57px',
            minWidth: '57px',
            width: '57px',
            lineHeight: '56px',
            '& .fab,& .fas,& .far,& .fal,& .material-icons': {
                fontSize: '32px',
                lineHeight: '56px',
            },
            '& svg': {
                width: '32px',
                height: '32px',
            },
        },
        '&$sm': {
            height: '30px',
            minWidth: '30px',
            width: '30px',
            '& .fab,& .fas,& .far,& .fal,& .material-icons': {
                fontSize: '17px',
                lineHeight: '29px',
            },
            '& svg': {
                width: '17px',
                height: '17px',
            },
        },
    },
    tooltip: {
        backgroundColor: COLORS.DARK_FUNCTION.FUNCTION_1,
        border: '1px solid',
        fontSize: '0.7rem',
        borderColor: COLORS.MAIN.LIGHT,
        textTransform: 'none',
        padding: 8,
        borderRadius: 0,
        fontFamily: '"Helvetica 55 Roman", "Helvetica 75", "Arial"',
    },
    tableButton: {
        backgroundColor: 'transparent',
        color: DEFAULT_BUTTON_COLOR,
        fill: DEFAULT_BUTTON_COLOR,
        '&:hover,&:focus': {
            backgroundColor: 'transparent',
            borderColor: 'none',
            transition: 'opacity .15s',
            color: SECONDARY_BUTTON_COLOR,
            fill: SECONDARY_BUTTON_COLOR,
        },
    },
};

export default OplButtonStyle;
